import { render, staticRenderFns } from "./PainelAtendimentos.vue?vue&type=template&id=01c5a1a8&scoped=true&"
import script from "./PainelAtendimentos.vue?vue&type=script&lang=js&"
export * from "./PainelAtendimentos.vue?vue&type=script&lang=js&"
import style0 from "./PainelAtendimentos.vue?vue&type=style&index=0&id=01c5a1a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c5a1a8",
  null
  
)

export default component.exports